import React from 'react';
import styles from './styles.scss';

const FormNote: React.FC<{}> = () => (
  <div className={styles.container}>
    <span className={styles.noteText}>
      <b>FYI:</b> Guests can only skip short-answer questions. They must answer multiple-choice questions.
    </span>
  </div>
);

export default FormNote;
